<template>
  <div>
    <head>
      <link rel="shortcut icon" href="assets/images/favicon.svg">
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
      <div id="layout-wrapper">
        <NavigationBar />

        <div id="content" class="content-minimize">
          <div class="page-content">
            <div class="container-fluid">

              <!-- Page Title -->
              <div class="row">
                <div class="col-12">
                  <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">Receive Stock</h4>
                    <div class="page-title-right">
                      <ol class="breadcrumb m-0">
                        <li class="breadcrumb-item"><a href="javascript:void(0);" @click="goTo('hospital-dashboard')">Hospital</a></li>
                        <li class="breadcrumb-item"><a href="javascript:void(0);" @click="goTo('pharmacy-inventory')">Inventory</a></li>
                        <li class="breadcrumb-item active">Receive Stock</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <!-- Left: Receipt Form -->
                <div class="col-lg-7">
                  <div class="card">
                    <div class="card-body">
                      <h5 class="mb-4"><i class="mdi mdi-package-down me-2 text-success"></i>Stock Receipt Details</h5>

                      <!-- Receipt Header -->
                      <div class="row mb-4">
                        <div class="col-md-6 mb-3">
                          <label class="form-label">Supplier <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" v-model="receipt.supplier" placeholder="Enter supplier name">
                        </div>
                        <div class="col-md-6 mb-3">
                          <label class="form-label">Invoice/GRN Number <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" v-model="receipt.invoiceNo" placeholder="Invoice or GRN number">
                        </div>
                        <div class="col-md-6 mb-3">
                          <label class="form-label">Receipt Date</label>
                          <input type="date" class="form-control" v-model="receipt.receiptDate" :max="today">
                        </div>
                        <div class="col-md-6 mb-3">
                          <label class="form-label">Notes</label>
                          <input type="text" class="form-control" v-model="receipt.notes" placeholder="Optional notes">
                        </div>
                      </div>

                      <hr>

                      <!-- Add Item Section -->
                      <h6 class="mb-3"><i class="mdi mdi-pill me-1 text-primary"></i>Add Items</h6>

                      <!-- Drug Search -->
                      <div class="mb-3">
                        <label class="form-label">Search Drug</label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-magnify"></i></span>
                          <input type="text" class="form-control" v-model="drugSearch" @input="searchDrugs" placeholder="Type drug name or code...">
                        </div>
                        <!-- Search Results -->
                        <div v-if="drugSearchResults.length > 0 && !selectedDrug" class="list-group mt-2 search-results-dropdown">
                          <a v-for="drug in drugSearchResults" :key="drug.drugID" href="javascript:void(0);"
                             class="list-group-item list-group-item-action" @click="selectDrug(drug)">
                            <div class="d-flex justify-content-between">
                              <div>
                                <strong>{{ drug.genericName }}</strong>
                                <small class="text-muted d-block">{{ drug.brandName }} - {{ drug.drugForm }} {{ drug.strength }}</small>
                              </div>
                              <small class="text-muted">{{ drug.drugCode }}</small>
                            </div>
                          </a>
                        </div>
                      </div>

                      <!-- Selected Drug Form -->
                      <div v-if="selectedDrug" class="border rounded p-3 mb-3 bg-light">
                        <div class="d-flex justify-content-between align-items-start mb-3">
                          <div>
                            <h6 class="mb-1">{{ selectedDrug.genericName }}</h6>
                            <small class="text-muted">{{ selectedDrug.brandName }} - {{ selectedDrug.drugForm }} {{ selectedDrug.strength }}</small>
                          </div>
                          <button type="button" class="btn btn-sm btn-outline-secondary" @click="clearSelectedDrug">
                            <i class="mdi mdi-close"></i>
                          </button>
                        </div>

                        <div class="row">
                          <div class="col-md-6 mb-3">
                            <label class="form-label">Batch Number <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="itemForm.batchNo" placeholder="e.g., BATCH001">
                          </div>
                          <div class="col-md-6 mb-3">
                            <label class="form-label">Expiry Date <span class="text-danger">*</span></label>
                            <input type="date" class="form-control" v-model="itemForm.expiryDate" :min="minExpiryDate">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4 mb-3">
                            <label class="form-label">Quantity <span class="text-danger">*</span></label>
                            <input type="number" class="form-control" v-model="itemForm.quantity" min="1" placeholder="0">
                          </div>
                          <div class="col-md-4 mb-3">
                            <label class="form-label">Unit Cost (KES) <span class="text-danger">*</span></label>
                            <input type="number" class="form-control" v-model="itemForm.unitCost" min="0" step="0.01" placeholder="0.00">
                          </div>
                          <div class="col-md-4 mb-3">
                            <label class="form-label">Total Cost</label>
                            <input type="text" class="form-control bg-light" :value="'KES ' + numberFormat(itemForm.quantity * itemForm.unitCost)" readonly>
                          </div>
                        </div>

                        <button type="button" class="btn btn-primary w-100" @click="addItemToReceipt" :disabled="!canAddItem">
                          <i class="mdi mdi-plus me-1"></i> Add to Receipt
                        </button>
                      </div>

                      <!-- Or Select from Common Drugs -->
                      <div v-if="!selectedDrug" class="mb-3">
                        <small class="text-muted">Or select from common drugs:</small>
                        <div class="d-flex flex-wrap gap-2 mt-2">
                          <button v-for="drug in commonDrugs" :key="drug.drugID" type="button"
                                  class="btn btn-outline-secondary btn-sm" @click="selectDrug(drug)">
                            {{ drug.genericName }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Right: Receipt Summary -->
                <div class="col-lg-5">
                  <div class="card">
                    <div class="card-header  text-white">
                      <h6 class="mb-0"><i class="mdi mdi-receipt me-2"></i>Receipt Summary</h6>
                    </div>
                    <div class="card-body">
                      <!-- Receipt Info -->
                      <div class="mb-3">
                        <small class="text-muted">Supplier:</small>
                        <div class="fw-medium">{{ receipt.supplier || '-' }}</div>
                      </div>
                      <div class="mb-3">
                        <small class="text-muted">Invoice/GRN:</small>
                        <div class="fw-medium">{{ receipt.invoiceNo || '-' }}</div>
                      </div>

                      <hr>

                      <!-- Items List -->
                      <h6 class="mb-3">Items ({{ receiptItems.length }})</h6>
                      
                      <div v-if="receiptItems.length === 0" class="text-center py-4 text-muted">
                        <i class="mdi mdi-package-variant-closed font-size-24 d-block mb-2"></i>
                        <small>No items added yet</small>
                      </div>

                      <div v-else class="receipt-items-list">
                        <div v-for="(item, index) in receiptItems" :key="index" class="receipt-item mb-2 p-2 border rounded">
                          <div class="d-flex justify-content-between align-items-start">
                            <div>
                              <div class="fw-medium">{{ item.drugName }}</div>
                              <small class="text-muted">
                                Batch: {{ item.batchNo }} | Exp: {{ formatDate(item.expiryDate) }}
                              </small>
                              <div class="mt-1">
                                <span class="badge bg-light text-dark">{{ item.quantity }} units</span>
                                <span class="badge bg-success ms-1">KES {{ numberFormat(item.totalCost) }}</span>
                              </div>
                            </div>
                            <button type="button" class="btn btn-sm btn-outline-danger" @click="removeItem(index)">
                              <i class="mdi mdi-delete"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <hr>

                      <!-- Totals -->
                      <div class="d-flex justify-content-between mb-2">
                        <span>Total Items:</span>
                        <strong>{{ totalQuantity }}</strong>
                      </div>
                      <div class="d-flex justify-content-between mb-3">
                        <span>Total Value:</span>
                        <strong class="text-success font-size-18">KES {{ numberFormat(totalValue) }}</strong>
                      </div>

                      <!-- Submit Button -->
                      <button type="button" class="btn btn-success w-100 btn-lg" @click="submitReceipt" 
                              :disabled="!canSubmit || submitting">
                        <span v-if="submitting">
                          <i class="mdi mdi-loading mdi-spin me-1"></i> Processing...
                        </span>
                        <span v-else>
                          <i class="mdi mdi-check me-1"></i> Confirm Receipt
                        </span>
                      </button>
                    </div>
                  </div>

                  <!-- Quick Actions -->
                  <div class="card">
                    <div class="card-body">
                      <h6 class="mb-3">Quick Actions</h6>
                      <div class="d-grid gap-2">
                        <button class="btn btn-outline-secondary" @click="goTo('pharmacy-inventory')">
                          <i class="mdi mdi-arrow-left me-1"></i> Back to Inventory
                        </button>
                        <button class="btn btn-outline-primary" @click="goTo('drug-catalog')">
                          <i class="mdi mdi-pill me-1"></i> Drug Catalog
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <footer class="footer">
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-6"></div>
                <div class="col-sm-6">
                  <div class="text-sm-end d-sm-block">County Hospital Management System</div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>

      <!-- Success Modal -->
      <div class="modal fade" id="successModal" tabindex="-1" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body text-center py-5">
              <div class="mb-4">
                <i class="mdi mdi-check-circle text-success" style="font-size: 80px;"></i>
              </div>
              <h4 class="mb-2">Stock Received Successfully!</h4>
              <p class="text-muted mb-1">{{ receiptItems.length }} items have been added to inventory</p>
              <p class="text-muted mb-4">Total Value: <strong>KES {{ numberFormat(totalValue) }}</strong></p>

              <div class="d-flex justify-content-center gap-2">
                <button class="btn btn-outline-secondary" @click="printReceipt">
                  <i class="mdi mdi-printer me-1"></i> Print GRN
                </button>
                <button class="btn btn-outline-primary" @click="newReceipt">
                  <i class="mdi mdi-plus me-1"></i> New Receipt
                </button>
                <button class="btn btn-primary" @click="goTo('pharmacy-inventory')">
                  <i class="mdi mdi-package-variant me-1"></i> View Inventory
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Toast Notification -->
      <ToastNotification ref="toast" />
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToastNotification from "@/components/hospital/ToastNotification.vue";
import { execute, hospital } from "@/api";

export default {
  name: "StockReceive",
  components: { NavigationBar, ToastNotification },
  data() {
    return {
      // Receipt Header
      receipt: {
        supplier: '',
        invoiceNo: '',
        receiptDate: new Date().toISOString().split('T')[0],
        notes: ''
      },

      // Drug Search
      drugSearch: '',
      drugSearchResults: [],
      drugSearchTimeout: null,
      selectedDrug: null,
      commonDrugs: [],

      // Item Form
      itemForm: {
        batchNo: '',
        expiryDate: '',
        quantity: '',
        unitCost: ''
      },

      // Receipt Items
      receiptItems: [],

      // State
      submitting: false,

      // Session
      facilityID: '',
      facilityName: '',
      sessionNames: '',
      sessionIdNo: ''
    };
  },
  computed: {
    today() {
      return new Date().toISOString().split('T')[0];
    },
    minExpiryDate() {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      return d.toISOString().split('T')[0];
    },
    canAddItem() {
      return this.selectedDrug &&
        this.itemForm.batchNo &&
        this.itemForm.expiryDate &&
        this.itemForm.quantity > 0 &&
        this.itemForm.unitCost >= 0;
    },
    totalQuantity() {
      return this.receiptItems.reduce((sum, item) => sum + Number(item.quantity), 0);
    },
    totalValue() {
      return this.receiptItems.reduce((sum, item) => sum + Number(item.totalCost), 0);
    },
    canSubmit() {
      return this.receipt.supplier &&
        this.receipt.invoiceNo &&
        this.receiptItems.length > 0;
    }
  },
  methods: {
    goTo(route) {
      this.$router.push('/' + route);
    },

    numberFormat(num) {
      return Number(num || 0).toLocaleString();
    },

    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    // Search Drugs
    searchDrugs() {
      if (this.drugSearchTimeout) clearTimeout(this.drugSearchTimeout);
      if (this.drugSearch.length < 2) {
        this.drugSearchResults = [];
        return;
      }

      this.drugSearchTimeout = setTimeout(() => {
        const data = new FormData();
        data.append("function", "searchDrugs");
        data.append("facilityID", this.facilityID);
        data.append("searchTerm", this.drugSearch);

        execute(data, hospital)
          .then((res) => {
            if (res.data.success) {
              this.drugSearchResults = res.data.data.drugs || [];
            }
          })
          .catch((e) => console.error(e));
      }, 300);
    },

    // Load Common Drugs
    loadCommonDrugs() {
      const data = new FormData();
      data.append("function", "getCommonDrugs");
      data.append("facilityID", this.facilityID);

      execute(data, hospital)
        .then((res) => {
          if (res.data.success) {
            this.commonDrugs = res.data.data.drugs || [];
          }
        })
        .catch((e) => console.error(e));
    },

    // Select Drug
    selectDrug(drug) {
      this.selectedDrug = drug;
      this.drugSearchResults = [];
      this.drugSearch = drug.genericName;
      this.itemForm = {
        batchNo: '',
        expiryDate: '',
        quantity: '',
        unitCost: drug.unitPrice || ''
      };
    },

    clearSelectedDrug() {
      this.selectedDrug = null;
      this.drugSearch = '';
      this.drugSearchResults = [];
      this.itemForm = { batchNo: '', expiryDate: '', quantity: '', unitCost: '' };
    },

    // Add Item to Receipt
    addItemToReceipt() {
      if (!this.canAddItem) return;

      this.receiptItems.push({
        drugID: this.selectedDrug.drugID,
        drugCode: this.selectedDrug.drugCode,
        drugName: this.selectedDrug.genericName,
        brandName: this.selectedDrug.brandName,
        drugForm: this.selectedDrug.drugForm,
        strength: this.selectedDrug.strength,
        batchNo: this.itemForm.batchNo,
        expiryDate: this.itemForm.expiryDate,
        quantity: Number(this.itemForm.quantity),
        unitCost: Number(this.itemForm.unitCost),
        totalCost: Number(this.itemForm.quantity) * Number(this.itemForm.unitCost)
      });

      this.clearSelectedDrug();
      this.$refs.toast.success('Item added to receipt');
    },

    // Remove Item
    removeItem(index) {
      this.receiptItems.splice(index, 1);
    },

    // Submit Receipt
    submitReceipt() {
      if (!this.canSubmit) return;

      this.submitting = true;

      // Process each item
      const promises = this.receiptItems.map(item => {
        const data = new FormData();
        data.append("function", "addInventoryItem");
        data.append("facilityID", this.facilityID);
        data.append("facilityName", this.facilityName);
        data.append("drugID", item.drugID);
        data.append("batchNo", item.batchNo);
        data.append("quantity", item.quantity);
        data.append("unitCost", item.unitCost);
        data.append("expiryDate", item.expiryDate);
        data.append("supplier", this.receipt.supplier);
        data.append("invoiceNo", this.receipt.invoiceNo);
        data.append("receivedBy", this.sessionNames);
        data.append("sessionNames", this.sessionNames);
        data.append("sessionIdNo", this.sessionIdNo);

        return execute(data, hospital);
      });

      Promise.all(promises)
        .then((results) => {
          this.submitting = false;
          const success = results.every(r => r.data.success);
          if (success) {
            const modal = new bootstrap.Modal(document.getElementById('successModal'));
            modal.show();
          } else {
            this.$refs.toast.error('Some items failed to process');
          }
        })
        .catch((e) => {
          this.submitting = false;
          this.$refs.toast.error('Error processing receipt');
        });
    },

    // New Receipt
    newReceipt() {
      bootstrap.Modal.getInstance(document.getElementById('successModal')).hide();
      this.receipt = {
        supplier: '',
        invoiceNo: '',
        receiptDate: new Date().toISOString().split('T')[0],
        notes: ''
      };
      this.receiptItems = [];
      this.clearSelectedDrug();
    },

    // Print Receipt
    printReceipt() {
      const printContent = `
        <div style="font-family: Arial, sans-serif; padding: 20px; max-width: 800px; margin: auto;">
          <h2 style="text-align: center;">${this.facilityName}</h2>
          <h3 style="text-align: center;">Goods Received Note (GRN)</h3>
          <hr>
          <p><strong>Supplier:</strong> ${this.receipt.supplier}</p>
          <p><strong>Invoice/GRN No:</strong> ${this.receipt.invoiceNo}</p>
          <p><strong>Date:</strong> ${this.formatDate(this.receipt.receiptDate)}</p>
          <hr>
          <table style="width: 100%; border-collapse: collapse; margin: 20px 0;">
            <thead>
              <tr style="background: #f5f5f5;">
                <th style="border: 1px solid #ddd; padding: 8px;">#</th>
                <th style="border: 1px solid #ddd; padding: 8px;">Drug Name</th>
                <th style="border: 1px solid #ddd; padding: 8px;">Batch No</th>
                <th style="border: 1px solid #ddd; padding: 8px;">Qty</th>
                <th style="border: 1px solid #ddd; padding: 8px;">Unit Cost</th>
                <th style="border: 1px solid #ddd; padding: 8px;">Total</th>
                <th style="border: 1px solid #ddd; padding: 8px;">Expiry</th>
              </tr>
            </thead>
            <tbody>
              ${this.receiptItems.map((item, i) => `
                <tr>
                  <td style="border: 1px solid #ddd; padding: 8px;">${i + 1}</td>
                  <td style="border: 1px solid #ddd; padding: 8px;">${item.drugName}</td>
                  <td style="border: 1px solid #ddd; padding: 8px;">${item.batchNo}</td>
                  <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.quantity}</td>
                  <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">KES ${this.numberFormat(item.unitCost)}</td>
                  <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">KES ${this.numberFormat(item.totalCost)}</td>
                  <td style="border: 1px solid #ddd; padding: 8px;">${this.formatDate(item.expiryDate)}</td>
                </tr>
              `).join('')}
            </tbody>
            <tfoot>
              <tr style="font-weight: bold;">
                <td colspan="3" style="border: 1px solid #ddd; padding: 8px;">Total</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${this.totalQuantity}</td>
                <td style="border: 1px solid #ddd; padding: 8px;"></td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">KES ${this.numberFormat(this.totalValue)}</td>
                <td style="border: 1px solid #ddd; padding: 8px;"></td>
              </tr>
            </tfoot>
          </table>
          <div style="margin-top: 50px;">
            <div style="display: inline-block; width: 45%;">
              <p>Received By: ___________________</p>
              <p>Sign: ___________________</p>
              <p>Date: ___________________</p>
            </div>
            <div style="display: inline-block; width: 45%; float: right;">
              <p>Verified By: ___________________</p>
              <p>Sign: ___________________</p>
              <p>Date: ___________________</p>
            </div>
          </div>
        </div>
      `;

      const printWindow = window.open('', '_blank');
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.print();
    }
  },
  mounted() {
    this.facilityID = sessionStorage.getItem("hospitalFacilityID") || '';
    this.facilityName = sessionStorage.getItem("hospitalFacilityName") || '';
    this.sessionNames = sessionStorage.getItem("sessionNames") || '';
    this.sessionIdNo = sessionStorage.getItem("sessionIdNo") || '';

    this.loadCommonDrugs();
  }
};
</script>

<style scoped>
.search-results-dropdown {
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  position: absolute;
  z-index: 100;
  background: #fff;
  width: calc(100% - 24px);
}

.receipt-items-list {
  max-height: 300px;
  overflow-y: auto;
}

.receipt-item:hover {
  background-color: #f8f9fa;
}
</style>
